export var REGISTER_RESOURCE = 'RA/REGISTER_RESOURCE';
export var registerResource = function (resource) { return ({
    type: REGISTER_RESOURCE,
    payload: resource,
}); };
export var UNREGISTER_RESOURCE = 'RA/UNREGISTER_RESOURCE';
export var unregisterResource = function (resourceName) { return ({
    type: UNREGISTER_RESOURCE,
    payload: resourceName,
}); };



//////////////////
// WEBPACK FOOTER
// ./node_modules/ra-core/esm/actions/resourcesActions.js
// module id = 963
// module chunks = 0